import React, { Component } from 'react';
import superagent from 'superagent';
import ReactLoading from 'react-loading';
import { Redirect, NavLink,Link} from 'react-router-dom';

import * as jsPDF from 'jspdf';
import html2canvas from 'html2canvas';



class DownloadForm extends Component {
    constructor(props)
    {
        super(props);
        this.onClickClose = this.onClickClose.bind(this);
        this.renderForm = this.renderForm.bind(this);
        this.generatePDF = this.generatePDF.bind(this);
        this.state = {
           

        }
    }

    generatePDF()
        {
            const input = document.getElementById('leave-form');

            html2canvas(input)
            .then((canvas) => {
                const imgData = canvas.toDataURL('image/png');
                const pdf = new jsPDF();
                pdf.addImage(imgData, 'PNG', 5, 20, 200, 267);
                let filename = "LeaveForm_"+this.props.selectedLeave.title;
                filename = filename + "_"+this.props.staff_details.core_details.EmpNo;
                filename = filename+".pdf";
                filename= filename.replace(/\s/g, "");
                pdf.save(filename);
            });

        }

    onClickClose()
    {
        
  
          this.props.nullifySelectedLeave();
  
       
    }

    renderPart2()
    {
        return(
            <div className="col-lg-11 col-md-11 block-centered row full-width" style={{marginTop:"40px"}}>
            <span><span className="col-lg-12  header-title">PART II </span>(Director of Operations -Administration)</span>
            
            <span className="col-lg-12">
                I do/do not recommend ……………………………………………..days leave (if notrecommended give reasons)<br/>
                <hr className="dotted-line"/>
            </span>

            <span className="col-lg-12">
                
                <span className="col-lg-6">
                    Signature:......................................
                </span>
                <span className="col-lg-6">
                    Date:...........................................
                </span>

            </span>      
        </div>

        );
    }


    renderForm()
    {
      const _this = this;

        return(
            <div id="leave-form" className ="row block-centered col-lg-12 col-md-12 full-width">
                    <div className = "report-header" className ="row block-centered col-lg-12 col-md-12 full-width">
                        <span className="col-lg-12 block-centered"><center><img src ="/img/logotuc.png" className="header-logo center"/> </center></span>
                        <span className = "col-lg-12 center-align times-n header-name">ELDORET TECHNICAL TRAINING INSTITUTE</span>
                        <span className = "col-lg-12 center-align comic header-address">"an ideology for betterment of humanity..."</span>
                        <span className = "col-lg-12 center-align comic header-address">P.O BOX 770-30100, ELDORET - KENYA</span>
                        <span className = "col-lg-12 text-center title-block" style={{marginTop:"20px"}}>
                            <span style = {{fontWeight:"bold"}}>{"LEAVE APPLICATION FORM "}</span>
                            <span>(Administrative Staff : Grade 7 - 13)</span>
                        </span>
                        <span className = "col-lg-12 text-center  ">
                            <span style={{paddingLeft:"10px", paddingRight:"10px"}}>(To be completed in quadruplicated and submitted to to Director of operation(Admin) at least 14 days before leave commences.)</span>
                        </span>
                    </div>

                    <div className="col-lg-11 col-md-11 block-centered row full-width">
                       <span className="col-lg-12  sec-title">PART I : Applicant Details</span>

                        <span className = "col-lg-12 "> 
                            <span className="col-lg-8" style={{paddingLeft:"0px"}}>
                                NAME :<span className="comic academic-info">{" "+ _this.props.staff_details.core_details.Names}</span>
                            </span>
                            <span className="col-lg-4">
                                P/F :<span className="comic academic-info">{" "+ _this.props.staff_details.core_details.EmpNo}</span>
                            </span>
                        </span>
                        <span className = "col-lg-12 "> 
                            <span className="col-lg-8" style={{paddingLeft:"0px"}}>
                                Designation :<span className="comic academic-info">{" "+ _this.props.staff_details.core_details.JobTitle}</span>
                            </span>
                            <span className="col-lg-4">
                                Department :<span className="comic academic-info">{" "+ _this.props.staff_details.core_details.Department}</span>
                            </span>
                        </span>
                        <span className = "col-lg-12 "> 
                            <span className="col-lg-6" style={{paddingLeft:"0px"}}>
                                Number of days applied for :<span className="comic academic-info">{" "+ _this.props.daysRequested}</span>
                            </span>
                            <span className="col-lg-3">
                                From  :<span className="comic academic-info">{" "+ _this.props.startDate.toISOString().slice(0, 10)}</span>
                            </span>
                            <span className="col-lg-3">
                                To :<span className="comic academic-info">{" "+ _this.props.returnDate}</span>
                            </span>
                        </span>
                        <span className="col-lg-12">
                                Nature of Leave :<span className="comic academic-info">{" "+ _this.props.selectedLeave.title}</span>
                        </span>
                        <span className="col-lg-12">
                                Contact Address :<span className="comic academic-info">{" "+ _this.props.staff_details.core_details.Address}</span>
                        </span>
                        <span className="col-lg-12">
                                Telephone Number :<span className="comic academic-info">{" "+ _this.props.staff_details.core_details.WTel}</span>
                        </span>
                        <span className="col-lg-12">
                                Name of the officer to act in your absence : ........................................................................
                        </span>
                        <span className="col-lg-12">
                                Applicant Signature : ........................................................................
                        </span>        
                            
                    </div>

                    <div className="col-lg-11 col-md-11 block-centered row full-width" style={{marginTop:"40px"}}>
                        <span className="col-lg-12  sec-title">PART II : Director of Operations -Administration</span>
                        
                        <span className="col-lg-12">
                            I do/do not recommend ……………………………………………..days leave (if not recommended give reasons)<br/>
                            <hr className="dotted-line"/>
                        </span>

                        <span className="col-lg-12">
                            
                            <span className="col-lg-6" style={{paddingLeft:"0px"}}>
                                Signature:......................................
                            </span>
                            <span className="col-lg-6">
                                Date:...........................................
                            </span>

                        </span>      
                    </div>

                    <div className="col-lg-11 col-md-11 block-centered row full-width" style={{marginTop:"40px"}}>
                        <span className="col-lg-12  sec-title">PART III : Deputy Principal AA/PRE/AP&F</span>
                        
                        <span className="col-lg-12 full-width">
                            Leave Recommended (if not recommended give reasons)
                        </span>
                        <span className="col-lg-12 full-width">
                            <hr className="dotted-line"/>
                        </span>

                        <span className="col-lg-12">
                            
                            <span className="col-lg-6" style={{paddingLeft:"0px"}}>
                                Signature:......................................
                            </span>
                            <span className="col-lg-6">
                                Date:...........................................
                            </span>

                        </span>      
                    </div>

                    <div className="col-lg-11 col-md-11 block-centered row full-width" style={{marginTop:"40px"}}>
                        <span className="col-lg-12  sec-title">PART IV : OFFICER IN CHARGE OF PERSONNEL RECORDS</span>

                        <ol>
                            <li>
                                <span>Annual Leave entitlement<br/>
                                .......................... days</span>
                            </li>
                            <li>
                                <span>Accumulated leave (with permission)<br/>
                                .......................... days</span>
                            </li>
                            <li>
                                <span>Leave taken<br/>
                                .......................... days</span>
                            </li>
                            <li>
                                <span>Total number of days requested<br/>
                                .......................... days</span>
                            </li>
                            <li>
                                <span>Balance<br/>
                                .......................... days</span>
                            </li>
                            <li>
                                <span>Applicant to resume duty on<br/>
                                .......................... days</span>
                            </li>
                            <li>
                                <span className="row col-lg-12 col-md-12 ">Information checked and certified/if incorrect specify the reasons</span>
                                <hr className="row col-lg-12 col-md-12 "/>
                                <hr className="row col-lg-12 col-md-12 "/>
                            </li>
                        </ol>
                        
                        <span className="col-lg-12">
                            
                            <span className="col-lg-6" style={{paddingLeft:"0px"}}>
                                Officer in charge of records, Name:....................................
                            </span>
                            <span className="col-lg-3">
                                Signature:..............................
                            </span>
                            <span className="col-lg-3">
                                Date:.............................
                            </span>

                        </span>      
                    </div>

                    <div className="col-lg-11 col-md-11 block-centered row full-width" style={{marginTop:"40px"}}>
                       <span className="col-lg-12  sec-title">PART VI </span>
                       <span className="col-lg-12 ">Records Officer - bring up on ................................For resumption of duty.</span>
                       <span className="col-lg-12">
                            <span className="col-lg-6" style={{paddingLeft:"0px"}}>
                                Sign:......................................
                            </span>
                            <span className="col-lg-6">
                                Date:...........................................
                            </span>

                        </span> 


                        
                            
                            
                    </div>
                    
            </div>
  
        );
    }
    


      
  

  
    


  render() {
      const _this = this;

    console.log("selected leave ", this.props.selectedLeave);

    
    if(this.props.selectedLeave == null)
    {
      return(<Redirect to = "/staff_ui/leave"/>);
    }

    if(this.props.daysRequested < 1)
    {
      return(<Redirect to = "/staff_ui/leave/specifydays"/>);
    }
    

    console.log("rendering form");


    return (
        
        <div className="col-lg-12 col-md-12 full-width">

            <div className="col-lg-12 col-md-12 full-width">
                <button className="btn  btn-round left" onClick={_this.onClickClose.bind(_this)} >Close<div className="ripple-container"></div></button>
                <button className="btn btn-primary btn-round right" onClick={_this.generatePDF.bind(_this)} >Download<div className="ripple-container"></div></button>   
            </div>

           {_this.renderForm()}
        </div>
    );
  }
}

export default DownloadForm;
